import { UserEntity } from '../../entity/user.entity';

export class UpdateUserAction {
  static type = '[AUTH] Update User';

  constructor(readonly payload: Partial<UserEntity>) {}
}
